<template>
  <div>
    <navigation/>
    <div class="pale-bgcolor" style="height: 800px">
      <div class="bright-contain" style="height: 700px">
        <div class="rg_title">
          个人中心
        </div>
        <div class="left-tab">
          <ul>
            <li data-for="baseInfo" class="tab-title active" :style="showStatus === 1 ? 'background: #dde3e9' : ''"
                @click="switchLeftTable(1)"><i class="icon-base-info"></i>基础信息
            </li>
            <li data-for="updatePasswd" class="tab-title" :style="showStatus === 2 ? 'background: #dde3e9' : ''"
                @click="switchLeftTable(2)"><i class="icon-pass"></i>修改密码
            </li>
          </ul>
        </div>
        <div class="right-content">
          <!-- 修改基本信息 -->
          <div id="baseInfo" v-if="showStatus === 1">
            <form action="../assets/user/update" id="userForm">
              <input type="hidden" name="userId"/>
              <div class="rg-list">
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 用户名</label>
                  <input type="text" readonly="readonly" disabled id="userName" v-model="userInfo.userName"
                         name="userName">
                  <span class="rgi-span"></span>
                </div>
                <div class="rg-items">
                  <label><i class="i-sign">∗</i>邮箱</label>
                  <input type="text" id="email" name="email" v-model="userInfo.email">
                  <el-tag type="danger" v-if="emailMsg != null">{{ emailMsg }}</el-tag>
                </div>
                <div class="rg-radio">
                  <label><i class="i-sign">∗</i> 用户类型</label>
                  <i style="font-style: normal;cursor: pointer" class="rg-radio-i"><input type="radio" name="userType"
                                                                                          value="2"
                                                                                          v-model="userInfo.userType"><b>企业</b></i>
                  <i style="font-style: normal;cursor: pointer" class="rg-radio-i"><input type="radio" name="userType"
                                                                                          value="1"
                                                                                          v-model="userInfo.userType"><b>个体</b></i>
                </div>
                <div class="rg-items rg-company" v-if="parseInt(userInfo.userType) === 2">
                  <label> <i class="i-sign">∗</i> 企业注册号</label>
                  <input type="text" id="companyNumber" v-model="userInfo.companyNumber">
                  <el-tag type="danger" v-if="companyNumberMsg != null">{{ companyNumberMsg }}</el-tag>
                </div>
                <div class="rg-items rg-company" v-if="parseInt(userInfo.userType) === 2">
                  <label><i class="i-sign">∗</i> 法定代表人姓名</label>
                  <input type="text" id="legalPensionName" v-model="userInfo.legalPerson">
                  <el-tag type="danger" v-if="legalPersonMsg != null">{{ legalPersonMsg }}</el-tag>
                </div>
                <div class="rg-items rg-company" v-if="parseInt(userInfo.userType) === 2">
                  <label><i class="i-sign">∗</i> 法人身份证号码</label>
                  <input type="text" id="legalPensionIdCard" v-model="userInfo.legalIdNumber">
                  <el-tag type="danger" v-if="legalIdNumberMsg != null">{{ legalIdNumberMsg }}</el-tag>
                </div>
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 申请人（或代理人）</label>
                  <input type="text" id="applyName" v-model="userInfo.applyName"/>
                  <el-tag type="danger" v-if="applyNameMsg != null">{{ applyNameMsg }}</el-tag>
                </div>
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 居民身份证号码</label>
                  <input type="text" id="idCard" v-model="userInfo.applyIdNumber">
                  <el-tag type="danger" v-if="applyIdNumberMsg != null">{{ applyIdNumberMsg }}</el-tag>
                </div>
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 手机号码</label>
                  <input type="text" id="mobile" v-model="userInfo.mobile">
                  <el-tag type="danger" v-if="mobileMsg != null">{{ mobileMsg }}</el-tag>
                </div>
                <div type="button" @click="saveUserInfo" style="width: 260px;margin-left: 188px;text-align: center"
                     class="rg_botton"
                >确定
                </div>
              </div>
            </form>
          </div>
          <!-- 修改密码  -->
          <div id="updatePasswd" v-if="showStatus === 2">
            <form id="passForm" action="../assets/user/passwd/update" method="post">
              <div class="rg-list">
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 输入原密码</label>
                  <input type="password" v-model="userInfo.oldPwd">
                  <el-tag type="danger" v-if="oldPwdMsg != null">{{ oldPwdMsg }}</el-tag>
                </div>
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 新密码</label>
                  <input type="password" v-model="userInfo.password">
                  <!--请输入6-16位数字、字母、下划线的组合-->
                  <el-tag type="danger" v-if="passwordMsg != null">{{ passwordMsg }}</el-tag>
                </div>
                <div class="rg-items">
                  <label><i class="i-sign">∗</i> 确认新密码</label>
                  <input type="password" v-model="userInfo.repeatPwd">
                  <!--与已输入密码保持一致-->
                  <el-tag type="danger" v-if="repeatPwdMsg != null">{{ repeatPwdMsg }}</el-tag>
                </div>
                <div @click="savePassword" style="width: 260px;margin-left: 188px;text-align: center" class="rg_botton">
                  确定
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilAPi from '../assets/js/utils'
import navigation from './navigation'

export default {
  name: 'updateUserInfo',
  components: {
    'navigation': navigation
  },
  data: function () {
    return {
      mobileMsg: null,
      passwordMsg: null,
      companyNumberMsg: null,
      userTypeMsg: null,
      legalPersonMsg: null,
      legalIdNumberMsg: null,
      applyNameMsg: null,
      applyIdNumberMsg: null,
      repeatPwdMsg: null,
      oldPwdMsg: null,
      emailMsg: null,
      showStatus: 1,
      isLogin: false,
      userInfo: {
        password: null,
        companyNumber: null,
        userType: null,
        legalPerson: null,
        legalIdNumber: null,
        applyName: null,
        applyIdNumber: null,
        mobile: null,
        repeatPwd: null,
        oldPwd: null,
        userName: null,
        verCode: null,
        emailCode: null,
        email: null
      }
    }
  },
  created() {
    this.getUserInfo()
  }, methods: {
    toIndex() {
      this.$message({
        message: '请先登录!',
        type: 'warning',
        duration: 5000
      })
      this.$router.push({
        path: '/index'
      })
    },
    getUserInfo() {
      let _self = this
      _self.axios.get(
        _self.api.getUserInfo
      ).then(res => {
        if (res.data.code === 10000) {
          this.isLogin = true
          this.userInfo = res.data.obj
          this.userInfo.password = null
        } else {
          this.$router.push({
            path: '/index'
          })
          this.isLogin = false
        }
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    /**
     * 修改密码
     */
    savePassword() {
      if (!this.checkPassword()) {
        return
      }
      let _self = this
      _self.axios.post(
        _self.api.resetPassword, this.userInfo,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.$message({
            message: res.data.message,
            type: 'success',
            duration: 5000
          })
          this.logout()
          this.$router.push({
            path: '/index'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     *  用户退出
     */
    logout() {
      let _self = this
      _self.axios.get(_self.api.logout).then(res => {
        this.isLogin = false
      }).catch(err => {
        this.$message.error(_self.config.ERRORMESSAGE)
      })
    },
    /**
     * 修改用户信息
     */
    saveUserInfo() {
      if (!this.checkUserInfo()) {
        return
      }
      let _self = this
      _self.axios.post(
        _self.api.updateInfo, this.userInfo,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        } else if (res.data.code !== 10000) {
          this.$message.error(res.data.message)
        } else {
          this.$message.success(res.data.message)
          this.$router.push({
            path: '/index'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    switchLeftTable(status) {
      this.showStatus = status
    },
    /**
     * 检查密码表单
     */
    checkPassword() {
      let flag = true
      if (this.userInfo.oldPwd == null || this.userInfo.oldPwd === '') {
        flag = false
        this.oldPwdMsg = '请输入原密码!'
      } else {
        this.oldPwdMsg = null
      }
      if (this.userInfo.password == null || this.userInfo.password === '') {
        flag = false
        this.passwordMsg = '请输入6-16位数字、字母、下划线的组合!'
      } else {
        this.passwordMsg = null
      }
      if (this.userInfo.repeatPwd == null || this.userInfo.repeatPwd === '') {
        flag = false
        this.repeatPwdMsg = '请出入确认密码!'
      } else if (this.userInfo.password != null && this.userInfo.repeatPwd != null && this.userInfo.password != this.userInfo.repeatPwd) {
        flag = false
        this.repeatPwdMsg = '两次密码不一致!'
      } else {
        this.repeatPwdMsg = null
      }
      return flag
    },
    /**
     * 检查用户信息表单
     */
    checkUserInfo() {
      let flag = true
      if (this.userInfo.email == null || this.userInfo.email === '') {
        flag = false
        this.emailMsg = '请输入正确的邮箱地址!'
      } else {
        this.emailMsg = null
      }
      if (this.userInfo.userType === 2 && (this.userInfo.companyNumber == null || this.userInfo.companyNumber === '')) {
        flag = false
        this.companyNumberMsg = '请输入2-20位数字、字母、下划线的组合!'
      } else {
        this.companyNumberMsg = null
      }
      if (this.userInfo.userType === 2 && (this.userInfo.legalPerson == null || this.userInfo.legalPerson === '')) {
        flag = false
        this.legalPersonMsg = '请输入法定代表人姓名!'
      } else {
        this.legalPersonMsg = null
      }
      if (this.userInfo.userType === 2 && (this.userInfo.legalIdNumber == null || this.userInfo.legalIdNumber === '')) {
        flag = false
        this.legalIdNumberMsg = '请输入法人身份证号码!'
      } else if (this.userInfo.userType === 2 && this.userInfo.legalIdNumber.length != 18) {
        flag = false
        this.applyIdNumberMsg = '法人身份证号码格式错误'
      } else {
        this.legalIdNumberMsg = null
      }
      if (this.userInfo.applyName == null || this.userInfo.applyName === '') {
        flag = false
        this.applyNameMsg = '请输入申请人（或代理人）名称!'
      } else {
        this.applyNameMsg = null
      }
      if (this.userInfo.applyIdNumber == null || this.userInfo.applyIdNumber === '') {
        flag = false
        this.applyIdNumberMsg = '请输入居民身份证号码'
      } else if (this.userInfo.applyIdNumber.length != 18) {
        flag = false
        this.applyIdNumberMsg = '居民身份证号码格式错误'
      } else {
        this.applyIdNumberMsg = null
      }
      if (this.userInfo.mobile == null || this.userInfo.mobile === '') {
        flag = false
        this.mobileMsg = '请输入正确的手机号码'
      } else if (this.userInfo.mobile.length != 11) {
        flag = false
        this.mobileMsg = '手机号码格式错误'
      } else {
        this.mobileMsg = null
      }
      return flag
    }
  }
}
</script>

<style>
@import '../assets/css/aicUser.css';
@import '../assets/css/newStyle.css';
@import '../assets/css/highlight.css';
@import '../assets/css/paging.css';
@import '../assets/css/bright.css';
</style>



// WEBPACK FOOTER //
// src/components/updateUserInfo.vue